import type {Property} from "@/src/modules/properties/types";

import type {AmenityConfig} from "./amenity-config";

export function getAmenityGuestLimit(
  property: Pick<Property, "rules"> | null | undefined,
  config: AmenityConfig,
): number | undefined {
  const rule = property?.rules?.find((r) => r.key === config.guestRuleKey);
  const value = rule?.value;
  if (value === undefined || value === null || value === "") return undefined;
  if (typeof value === "boolean" || typeof value === "object") return undefined;
  const n = Number(value);
  return Number.isFinite(n) ? n : undefined;
}
